export default (() => {

    const global = { 
        elements: {},
        pageData: {},
        requestData: {}
    };

    function initialise (data) {
        _cacheDom();
        _cachePageData(data);
        _initialiseData();
        _bindSignalREvents();
        _bindEvents();

        global.pageData.connection.hub.start();
    }

    function _cacheDom () {
        // Announcements
        global.elements.introAnnouncement = document.querySelector('[data-intro-announcement]');

        // Remaining Allowance
        global.elements.remainingAllowance = document.querySelector('[data-remaining-allowance]');
        global.elements.remainingAllowanceLoading = document.querySelector('[data-remaining-allowance-loading]');
        global.elements.remainingAllowanceAmount = document.querySelector('[data-remaining-allowance-amount]');
        
        // Recurring Payment
        global.elements.setupDirectDebitButton = document.querySelector('[data-setup-direct-debit-button]');
        global.elements.cancelDirectDebitButton = document.querySelector('[data-recurring-payment-cancel-button]');
        global.elements.cancelDirectDebitModal = document.querySelector('[data-recurring-payment-cancel-modal]');
        global.elements.directDebitContainerLoading = document.querySelector('[data-recurring-payments-loading]');
        global.elements.directDebitContainerCard = document.querySelector('[data-recurring-payments-card]');
        global.elements.directDebitContainer = document.querySelector('[data-recurring-payments]');
        global.elements.directDebitContainerContent = document.querySelector('[data-recurring-payments-content]');

        // Recurring Payment - Amend modal
        global.elements.amendModalCancelButton = document.querySelector('[data-amend-direct-debit-cancel]');
        global.elements.amendModalUpdateButton = document.querySelector('[data-amend-direct-debit-update]');
        global.elements.amendModal = document.querySelector('[data-recurring-payment-amend-modal]');
        global.elements.amendModalForm = document.querySelector('[data-amend-direct-debit-cancel-form]');
        
        // Recurring Payment - Cancel modal
        global.elements.cancelDirectDebitModalCancel = document.querySelector('[data-cancel-recurring-payment-modal-cancel]');
    }
    
    function _cachePageData (data) {
        global.pageData = data; 
    }
    
    function _initialiseData () {
        global.requestData.jisaRemainingAllowanceUrl = document.querySelector('[data-jisa-remaining-allowance-url]').getAttribute('data-jisa-remaining-allowance-url');
        global.requestData.cancelRecurringPaymentUrl = document.querySelector('[data-cancel-recurring-payment-url]')?.getAttribute('data-cancel-recurring-payment-url');
        global.requestData.recurringPaymentsUrl = document.querySelector('[data-recurring-payments-url]')?.getAttribute('data-recurring-payments-url');
        global.requestData.amendRecurringPaymentUrl = document.querySelector('[data-amend-direct-debit-submit-url]')?.getAttribute('data-amend-direct-debit-submit-url');
        global.requestData.introDismissedUrl = document.querySelector('[data-update-intro-dismissed-url]').getAttribute('data-update-intro-dismissed-url');
    }

    function _bindSignalREvents() {
        global.pageData.connection[global.pageData.hubName].client.contributorRecurringPaymentUpdated = _refreshPanels;
        global.pageData.connection[global.pageData.hubName].client.contributorRecurringPaymentCancelled = _removeDirectDebitPanel;
    }

    function _bindEvents () {
        if (global.elements.introAnnouncement) {
            global.elements.introAnnouncement.oncloseclick = _introAnnouncementDismiss;
        }

        global.elements.amendModalCancelButton?.addEventListener('click', () =>  global.elements.amendModal.open = false);
        global.elements.amendModalUpdateButton?.addEventListener('click', _updateRecurringPaymentAndDisablePanel);
        global.elements.cancelDirectDebitButton?.addEventListener('click', () => global.elements.cancelDirectDebitModal.open = true);
        global.elements.cancelDirectDebitModalCancel?.addEventListener('click', _cancelRecurringPayment);
    }

    function _introAnnouncementDismiss () {
        const config = {
            url: global.requestData.introDismissedUrl,
            method: 'PUT'
        };

        wealthify.request.send(config);
    }

    function _refreshPanels(portfolioId) {
        if (!global.elements.directDebitContainer) {
            return;
        }

        if (portfolioId !== global.pageData.portfolioId) {
            return;
        }

        const config = {
            url: global.requestData.recurringPaymentsUrl,
            method: 'GET'
        };
        
        wealthify.request.send(config).then((response) => {
            global.elements.directDebitContainer.innerHTML = response;

            initialise(global.pageData);

            _refreshRemainingAllowancePanel();
        });
    }

    function _refreshRemainingAllowancePanel () {

        const config = {
            url: global.requestData.jisaRemainingAllowanceUrl,
            method: 'GET'
        };

        global.elements.remainingAllowanceLoading.classList.remove('u-display__none');
        global.elements.remainingAllowanceAmount.classList.add('u-display__none');
        
        wealthify.request.send(config).then((response) => global.elements.remainingAllowance.innerHTML = response);
    }
    
    function _updateRecurringPaymentAndDisablePanel() {
        const isFormDirty = wealthify.form.isDirty(global.elements.amendModalForm);
        
        if (!isFormDirty) {
            global.elements.amendModal.open = false;

            return;
        }

        const isFormValid = global.elements.amendModalForm.checkValidity();

        if (isFormValid) {
            const config = {
                url: global.requestData.amendRecurringPaymentUrl,
                data: wealthify.form.getFormData(global.elements.amendModalForm),
            };
            
            wealthify.request.send(config).then(() => {
                global.elements.amendModal.open = false;

                global.elements.directDebitContainerLoading.classList.remove('u-display__none');
                global.elements.directDebitContainerContent.classList.add('u-display__none');
            });
        }
    }

    function _cancelRecurringPayment(){
        global.elements.cancelDirectDebitModalCancel.disabledProp = true;
        window.location.href = global.requestData.cancelRecurringPaymentUrl;
    }

    function _removeDirectDebitPanel() {
        global.elements.setupDirectDebitButton.classList.remove('u-display__none');
        global.elements.directDebitContainerCard?.classList.add('u-display__none');
    }

    return { initialise };
})();